module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/d709e33922b34f6056736b4b4f505d5b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pass_hide.svg
// module id = TwFx
// module chunks = 1